import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import kr from "./locales/kr.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGS = ["kr", "en"];
export const DEFAULT_LANG = "kr";

i18n.use(initReactI18next).init({
  resources: {
    kr: { translation: kr },
    en: { translation: en },
  },
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: SUPPORTED_LANGS,
  interpolation: { escapeValue: false },
  returnNull: false,
  returnEmptyString: true, // 영문에서 의도적으로 비운 문구가 한글로 대체되지 않도록
});

export default i18n;
